// extracted by mini-css-extract-plugin
module.exports = {"root":"GoToCompletePromo_root__2vSEu","icon":"GoToCompletePromo_icon__2-FBS","text":"GoToCompletePromo_text__3kTct","link":"GoToCompletePromo_link__3JlLW"};